module.exports = __webpack_public_path__ + "static/img/gongjianhong.13b528e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gongjianhong.png
// module id = mNXZ
// module chunks = 19